import React from "react";
import { Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";

const Ranking = ({ currentActivity, rankingSelections }) => {
  console.log(currentActivity, rankingSelections);

  // Get the user's selected ranking order (default to an empty array)
  const userOrder = rankingSelections?.map((item) => item.Value) || [];

  // Get the correct ranking order from JSON (assuming 'Options' contains ordered values)
  const correctOrder = currentActivity.Options.map((option) => option.Value);

  // Check if the user's ranking matches the correct order
  const isCorrect = JSON.stringify(userOrder) === JSON.stringify(correctOrder);

  return (
    <>
      {isCorrect ? (
        <>
          <CheckCircleOutlineIcon sx={{ fontSize: 40, color: "green" }} />
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "green",
              marginTop: 1,
            }}
          >
            Correct Ranking!
          </Typography>
        </>
      ) : (
        <>
          <CancelIcon sx={{ fontSize: 40, color: "red" }} />
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
              color: "red",
              marginTop: 1,
            }}
          >
            Incorrect Ranking!
          </Typography>
        </>
      )}

      {/* Display rationale if available */}
      {currentActivity?.Options?.map((option, index) => {
        // Check if option has Text or ContentId in Rationale
        const rationaleText = option.Rationale?.Text?.trim();
        const rationaleContentId = option.Rationale?.ContentId?.trim();

        if (rationaleText) {
          // If there's Text in the rationale, display it
          return (
            <Typography
              key={index}
              sx={{
                fontSize: "0.75rem",
                color: "text.secondary",
                padding: "8px",
                marginTop: 1,
              }}
            >
              {`Rationale: ${rationaleText}`}
            </Typography>
          );
        } else if (rationaleContentId) {
          // If there's only ContentId, you could handle it accordingly
          return (
            <Typography
              key={index}
              sx={{
                fontSize: "0.75rem",
                fontStyle: "italic",
                color: "text.secondary",
                padding: "8px",
                marginTop: 1,
              }}
            >
              {`Rationale ID: ${rationaleContentId}`}
            </Typography>
          );
        }

        // If neither Text nor ContentId is available, do nothing or show a fallback
        return null;
      })}
    </>
  );
};

export default Ranking;
